import { ErrorMessage, Field } from 'formik';
import React from 'react';

const InputBox = ({ label, type, name, id, placeholder }) => {
  return (
    <div className='flex w-full flex-col'>
      {label ? (
        <label htmlFor={id} className='text-sm font-medium leading-none text-brand-navy'>
          {label}
        </label>
      ) : null}
      <Field
        className='mt-1 flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-ui-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring'
        type={type}
        id={id}
        name={name}
        placeholder={placeholder}
      />
      <ErrorMessage
        name={name}
        render={(msg) => (
          <div className='mt-2 flex gap-1 text-left text-[12px] font-normal leading-none text-red-700'>
            {msg}
          </div>
        )}
      />
    </div>
  );
};

export default InputBox;
